<template>
  <div class="profile">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="个人中心"
      fixed
    />

    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div v-if="isLoggedIn" class="user-info">
        <van-image
          round
          width="64"
          height="64"
          :src="userInfo.avatar"
        />
        <div class="user-detail">
          <div class="nickname">{{ userInfo.nickname }}</div>
          <div class="user-id">ID: {{ userInfo.userId }}</div>
        </div>
      </div>
      <div v-else class="not-logged-in">
        <van-image
          round
          width="80"
          height="80"
          src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
        />
        <div class="welcome-text">欢迎来到个人中心</div>
        <van-button round block type="primary" to="/login" style="margin-top: 16px;">登录/注册</van-button>
      </div>
      <div v-if="isLoggedIn" style="margin-top: 16px;">
        <van-button round block type="danger" @click="logout">退出登录</van-button>
      </div>
    </div>

    <!-- 我的订单 -->
    <div class="order-section">
      <van-cell title="我的订单" is-link value="查看全部订单" to="/orders" />
      <div class="order-types">
        <div class="order-item" v-for="(item, index) in orderTypes" :key="index">
          <van-icon :name="item.icon" />
          <span>{{ item.text }}</span>
          <van-badge v-if="item.count" :content="item.count" />
        </div>
      </div>
    </div>

    <!-- 我的服务 -->
    <div class="service-section">
      <van-cell-group>
        <van-grid :column-num="4" :border="false">
          <van-grid-item
            v-for="(item, index) in services"
            :key="index"
            :icon="item.icon"
            :text="item.text"
          />
        </van-grid>
      </van-cell-group>
    </div>

    <!-- 其他设置 -->
    <div class="settings-section">
      <van-cell-group>
        <van-cell title="收货地址" is-link to="/address">
          <template #icon>
            <van-icon name="location-o" class="cell-icon" />
          </template>
        </van-cell>
        <van-cell title="我的收藏" is-link to="/favorites">
          <template #icon>
            <van-icon name="like-o" class="cell-icon" />
          </template>
        </van-cell>
        <van-cell title="客服中心" is-link to="/service">
          <template #icon>
            <van-icon name="service-o" class="cell-icon" />
          </template>
        </van-cell>
        <van-cell title="设置" is-link to="/settings">
          <template #icon>
            <van-icon name="setting-o" class="cell-icon" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
	
	<div style="padding: 40px 0;"><a href="https://beian.miit.gov.cn/">琼ICP备2025057209号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  data() {
    return {
      userInfo: {
        nickname: '张三',
        userId: '88888888',
        avatar: 'https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg'
      },
      isLoggedIn: false,
      orderTypes: [
        { icon: 'pending-payment', text: '待付款', count: 2 },
        { icon: 'logistics', text: '待发货', count: 1 },
        { icon: 'send-gift-o', text: '待收货', count: 0 },
        { icon: 'comment-o', text: '待评价', count: 3 }
      ],
      services: [
        { icon: 'coupon-o', text: '优惠券' },
        { icon: 'balance-o', text: '钱包' },
        { icon: 'points', text: '积分' },
        { icon: 'vip-card-o', text: '会员' },
        { icon: 'gift-o', text: '礼品卡' },
        { icon: 'service-o', text: '客服' },
        { icon: 'share-o', text: '分享' },
        { icon: 'setting-o', text: '设置' }
      ]
    }
  },
  created() {
    this.checkLoginStatus()
  },
  methods: {
    checkLoginStatus() {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null')
      if (currentUser) {
        this.userInfo = {
          nickname: currentUser.username,
          userId: currentUser.username,
          avatar: 'https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg'
        }
        this.isLoggedIn = true
      } else {
        this.isLoggedIn = false
      }
    },
    logout() {
      localStorage.removeItem('currentUser')
      this.isLoggedIn = false
      this.$toast.success('退出登录成功')
    }
  }
}
</script>

<style scoped>
.profile {
  min-height: 100vh;
  background: #f7f8fa;
  padding-top: 26px;
}

.user-card {
  background: linear-gradient(to right, #86cfff, #4ac6ff);
  padding: 20px 16px;
  color: #fff;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-detail {
  margin-left: 16px;
}

.nickname {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.user-id {
  font-size: 12px;
  opacity: 0.8;
}

.order-section {
  margin-top: 12px;
  background: #fff;
}

.order-types {
  display: flex;
  padding: 15px 0;
}

.order-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;
  position: relative;
}

.order-item .van-icon {
  font-size: 24px;
  margin-bottom: 4px;
}

.order-item span {
  font-size: 12px;
  color: #646566;
}

.service-section {
  margin-top: 12px;
}

.settings-section {
  margin-top: 12px;
}

:deep(.van-grid-item__content) {
  padding: 16px 8px;
}

:deep(.van-grid-item__icon) {
  font-size: 24px;
}

:deep(.van-grid-item__text) {
  font-size: 12px;
  margin-top: 8px;
}

:deep(.van-cell-group__title) {
  padding: 16px 16px 8px;
  font-size: 14px;
  color: #969799;
}

:deep(.van-cell__title) {
  display: flex;
  align-items: center;
  text-align: left;
  flex: 3;
}

:deep(.van-cell__value) {
  flex: 1;
}

.cell-icon {
  margin-right: 8px;
  font-size: 18px;
  color: #323233;
}

.not-logged-in {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.welcome-text {
  margin-top: 12px;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}
</style>